
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/[eventSlug]/subscriptions",
      function () {
        return require("private-next-pages/events/[eventSlug]/subscriptions.tsx");
      }
    ]);
  